import { BenefitData, InsuranceListItemProps } from "../InsuranceListItem";

/**
 * Shared types used across multiple transformers
 * Transformer-specific types are located in their respective transformer files
 */

// Generic transformer function type - used by the main mapping system
export type TransformerFunction<TInput = unknown, TOutput = unknown> = (
  componentData: TInput,
  callbacks?: Record<string, unknown>
) => TOutput;

// Re-export types from InsuranceListItem for convenience
export type { InsuranceListItemProps, BenefitData };
